import { itkComponentsReducer } from "@itk/mui-components";

export const initialItkComponentsReducerState: ReturnType<typeof itkComponentsReducer> = {
  buttonReducer: {
    globalExcludedCalls: [],
    ongoingCalls: []
  }
};
